import React, { useState, useEffect } from 'react';
import { historyService } from '../services/api';

function History() {
  const [history, setHistory] = useState({
    content: '',
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const response = await historyService.get();
        if (response.data) {
          setHistory({
            content: response.data.content || '',
          });
        }
      } catch (error) {
        console.error('Error fetching history:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchHistory();
  }, []);

  if (loading) {
    return (
      <div className="bg-gray-50 min-h-screen">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">در حال بارگذاری...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">تاریخچه نشریه</h1>
          <p className="text-xl text-blue-100">مسیر تکامل نشریه مجری</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-16">
        {history.content ? (
          <div className="bg-white rounded-xl shadow-md p-8">
            <div className="text-gray-700 leading-relaxed whitespace-pre-wrap">
              {history.content}
            </div>
          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-md p-8 text-center text-gray-500">
            <p>اطلاعاتی برای نمایش وجود ندارد</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default History;
